var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgGauge(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    fill: "none",
    viewBox: "0 0 26.833 26.833",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "#000",
    strokeWidth: 0
  }, /*#__PURE__*/React.createElement("path", {
    d: "m19.376 6.6455c-0.20792 0-0.41557 0.07963-0.57422 0.23828l-4.4414 4.4414c-0.03277 0.03276-0.04822 0.07479-0.07422 0.11133-0.26691-0.11755-0.55876-0.18555-0.86914-0.18555-1.1967 0-2.168 0.96932-2.168 2.166 0 1.1966 0.97127 2.166 2.168 2.166 1.1966 0 2.166-0.96942 2.166-2.166 0-0.3095-0.06669-0.60282-0.18359-0.86914 0.03605-0.02576 0.07701-0.04185 0.10937-0.07422l4.4414-4.4414c0.3173-0.3173 0.3173-0.83114 0-1.1484-0.15865-0.15865-0.36629-0.23828-0.57422-0.23828z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m12.692 6.6862c1.1-0.1189 2.2123 0.0334 3.2398 0.4436 0.4167 0.1663 0.8894-0.0367 1.0558-0.4534 0.1664-0.4168-0.0366-0.8895-0.4534-1.0558-1.2739-0.5086-2.6531-0.6974-4.0168-0.55-1.3638 0.1474-2.6707 0.6266-3.8066 1.3957-1.1358 0.7691-2.0661 1.8046-2.7093 3.0161-0.6433 1.2116-0.9801 2.5622-0.981 3.9339-3e-4 0.4487 0.3633 0.8127 0.812 0.813s0.8127-0.3632 0.813-0.812c7e-4 -1.1063 0.2723-2.1957 0.7912-3.1728 0.5188-0.9771 1.2691-1.8123 2.1852-2.4326s1.9702-1.0068 3.0701-1.1257z",
    clipRule: "evenodd",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m 13.417,3 c 5.7529,0 10.417,4.6637 10.417,10.417 0,5.7529 -4.6637,10.417 -10.417,10.417 C 7.664,23.834 3,19.1703 3,13.417 3,7.664 7.6637,3 13.417,3 Z M 26.834,13.417 C 26.834,6.0071 20.8272,0 13.417,0 6.0071,0 0,6.0068 0,13.417 c 0,7.4098 6.0068,13.417 13.417,13.417 7.4098,0 13.417,-6.0068 13.417,-13.417 z",
    clipRule: "evenodd",
    fillRule: "evenodd"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgGauge);
export default __webpack_public_path__ + "static/media/gauge.2ee530b994f244c4ad684d68dd63d616.svg";
export { ForwardRef as ReactComponent };